import { LoginCommand } from "./commands/LoginCommand";
import { LogoutCommand } from "./commands/LogoutCommand";
import { TokenValidationCommand } from "./commands/TokenValidationCommand";

export class AuthCommandFacade {
  login(token) {
    return new LoginCommand(token).execute();
  }

  logout() {
    return new LogoutCommand().execute();
  }

  isTokenValid(token) {
    return new TokenValidationCommand(token).execute();
  }
}
